import React, { Fragment, useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap'
import TextField from '@material-ui/core/TextField';
import { DatePicker, KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import ModalUI from '../../../shared/components/Modal';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import TypeExpensesForm from './ExpensesType/TypeExpensesForm';
import DataReactTableExpenses from './DataReactTableExpenses';
import Spinner from 'react-bootstrap/Spinner';
import renderDropZoneField from '../../../shared/components/form/DropZone';
import { useDropzone } from 'react-dropzone'
import { formatNumber } from '../../Utils/Money';

const ExpensesSection = () => {
    const [isMounted, setIsMounted] = useState(false);
    const [openTypeExpensesForm, setOpenTypeExpensesForm] = useState(false);
    const [errors, setErrors] = useState({});
    const [nameExpense, setNameExpense] = useState('');
    const [noteExpense, setNoteExpense] = useState('');
    const [typeExpense, setTypeExpense] = useState(null);
    const [typeExpenseSelected, setTypeExpenseSelected] = useState('');
    const [dateExpense, setDateExpense] = useState(new Date());
    const [thirdSelected, setThirdSelected] = useState('');
    const [thirds, setThirds] = useState([]);
    const [mount, setMount] = useState(0);
    const [taxes, setTaxes] = useState([]);
    const [taxeName, setTaxeName] = useState('');
    const [taxeValue, setTaxeValue] = useState(0);
    const [typeOfPayment, setTypeOfPayment] = useState(null);
    const [reference, setReference] = useState('');
    const [fileExpense, setFileExpense] = useState(null);
    const [expenses, setExpenses] = useState([]);
    const [loadTable, setLoadTable] = useState(false);
    const [idTaxeGeneric, setIdTaxeGeneric] = useState(0);
    const [editExpense, setEditExpense] = useState(false);
    const [idExpense, setIdExpense] = useState('');
    const [files, setFiles] = useState([]);
    const [updateTypeExpenseSelect, setupdateTypeExpenseSelect] = useState(false);

    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

    useEffect(() => {
        setIsMounted(true);
        getExpenses();
        listThirds();
        getTypesExpenses();
        return () => {
            setIsMounted(false);
        }
    }, [isMounted])


    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/jpeg, image/png',
        onDrop: (acceptedFiles) => {
            setFiles(acceptedFiles.map((file) => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })))
        }
    })

    const validateForm = () => {
        const errors = {};
        var error = false;
        if (nameExpense == "") {
            errors.nombre = "Campo obligatorio";
            error = true;
        }

        if (noteExpense == "") {
            errors.nota = "Campo obligatorio";
            error = true;
        }

        if (typeExpenseSelected == '') {
            errors.tipo_gasto = "Seleccione el tipo de gasto";
            error = true;
        }

        /* if (moment(dateExpense).format("YYYY/MM/DD") === moment(new Date()).format("YYYY/MM/DD")) {
            errors.fecha = "Seleccione una fecha";
        } */

        if (dateExpense == null && dateExpense == undefined) {
            errors.fecha = "Seleccione una fecha";
            error = true;
        }

        if (mount == 0 && mount == '') {
            errors.importe = "Digite el Importe";
            error = true;
        }

        /*
        if (Object.entries(taxes).length === 0) {
            errors.impuestos = "Digite el impuesto";
            error = true;
        }*/

        if (typeOfPayment == null && typeOfPayment == '') {
            errors.forma_pago = "Seleccione una forma de pago";
            error = true;
        }

        if (reference == '') {
            errors.referencia = "Digite una referencia";
            error = true;
        }

        /* if (fileExpense == null && fileExpense == undefined) {
            errors.imagenRe = "Seleccione una imagen (Recibo)";
            error = true;
        } */

        console.log("ERRORSFORM", errors);
        setErrors(errors);
        return error;
    }

    const images = files.map((file) => (
        <div key={file.name}>
            <div>
                <img src={file.preview} style={{ width: '200px' }} alt='preview'></img>
            </div>
        </div>
    ))

    const getExpenses = async () => {
        setLoadTable(true);

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'gastos/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("EXPENSES", data, "isMounted:", isMounted)
                setExpenses(data);
                setLoadTable(false);
            })
            .catch((error) => {
                console.log(error)
            })
    };


    const listThirds = async () => {
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}tercero/listar-terceros-indicadores`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            return response.json();
        }).then(data => {
            console.log("Thirds", data)
            setThirds(data);
        }).catch((error) => {
            console.log(error)
        });
    }

    const saveExpense = () => {
        if (!validateForm()) {
            var dataFile = new FormData();
            dataFile.append("nombre", nameExpense);
            dataFile.append("nota", noteExpense);
            dataFile.append("tipo_gasto", typeExpenseSelected);
            dataFile.append("importe", mount);
            dataFile.append("id_tercero", thirdSelected);
            dataFile.append("impuestos", JSON.stringify(taxes));
            dataFile.append("forma_pago", typeOfPayment);
            dataFile.append("referencia", reference);
            dataFile.append("fecha", moment(dateExpense).format("YYYY/MM/DD"));
            dataFile.append("imagen", fileExpense);

            fetch(process.env.REACT_APP_PUBLIC_URL + 'gastos/create', {
                method: 'POST',
                headers: {
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: dataFile
            })
                .then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then(data => {
                    console.log(data);
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                    setNameExpense('');
                    setNoteExpense('');
                    setTypeExpenseSelected('');
                    setMount('');
                    setThirdSelected('');
                    setTaxes([]);
                    setTypeOfPayment(null);
                    setReference('');
                    setFileExpense(null);
                    getExpenses();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    const updateExpense = () => {
        if (!validateForm()) {
            var dataFile = new FormData();
            dataFile.append("nombre", nameExpense);
            dataFile.append("nota", noteExpense);
            dataFile.append("tipo_gasto", typeExpenseSelected);
            dataFile.append("importe", mount);
            dataFile.append("id_tercero", thirdSelected);
            dataFile.append("impuestos", JSON.stringify(taxes));
            dataFile.append("forma_pago", typeOfPayment);
            dataFile.append("referencia", reference);
            dataFile.append("fecha", moment(dateExpense).format("YYYY/MM/DD"));
            dataFile.append("imagen", fileExpense);
            dataFile.append("id_gasto", parseInt(idExpense))

            fetch(process.env.REACT_APP_PUBLIC_URL + 'gastos/update', {
                method: 'PUT',
                headers: {
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: dataFile
            })
                .then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then(data => {
                    console.log(data);
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Gasto actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                    setNameExpense('');
                    setNoteExpense('');
                    setTypeExpenseSelected('');
                    setMount('');
                    setThirdSelected('');
                    setTaxes([]);
                    setTypeOfPayment(null);
                    setReference('');
                    setFileExpense(null);
                    setEditExpense(false);
                    getExpenses();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
    }

    const includeTax = (taxName, taxValue) => {

        let taxesInclude = taxes;
        taxesInclude.push({ impuesto: taxName, valor: taxValue, id: idTaxeGeneric });

        let newId = idTaxeGeneric + 1;
        let arr = taxesInclude.find((txIn) => txIn.id === newId);
        console.log("ARR", arr)
        if (arr) {
            newId = idTaxeGeneric + 10;
        }
        setIdTaxeGeneric(newId);

        setTaxes(taxesInclude);
        setTaxeName('');
        setTaxeValue(0);
        console.log("STATETAXES", taxes);
    }

    const removeTax = (id) => {
        let newTaxesArr = taxes.filter((tax) => tax.id !== id);
        setTaxes(newTaxesArr);

    }

    const editExpenseFromTable = (expense) => {
        setEditExpense(true);
        setIdExpense(expense.id_gasto)
        setNameExpense(expense.nombre);
        setNoteExpense(expense.nota)
        setTypeExpenseSelected(expense.tipo_gasto);
        setDateExpense(moment(expense.fecha).format("YYYY/MM/DD"));
        setThirdSelected(expense.id_tercero);
        setMount(expense.importe);
        setTaxes(expense.impuestos.impuestos);
        setTypeOfPayment(expense.forma_pago);
        setReference(expense.referencia);
    }

    const reactTableDataExpenses = {
        tableHeaderData: [{
            Header: 'NOMBRE',
            accessor: 'nombre',
            //disableGlobalFilter: true,
            width: 65,
        },
        {
            Header: 'TIPO DE GASTO',
            accessor: 'nombre_gasto',
        },
        {
            Header: 'FECHA DEL GASTO',
            accessor: 'fecha',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("YYYY/MM/DD") : null}</label>
            )
        },
        {
            Header: 'REFERENCIA',
            accessor: 'referencia',
        },
        {
            Header: 'FORMA DE PAGO',
            accessor: 'forma_pago',
        },
        {
            Header: 'NOTA',
            accessor: 'nota',
        },
        {
            Header: 'VALOR',
            accessor: 'importe',
            Cell: row => (
                <label>{row.value !== null && row.value !== undefined ? "$" + formatNumber(row.value) : ''}</label>
            ),
        },
        ],
        tableRowsData: expenses
    };

    const LoadInfo = () => {
        return (<DataReactTableExpenses
            reactTableData={reactTableDataExpenses}
            refresh={getExpenses}
            editExpenseFromTable={editExpenseFromTable}
        />)
    }

    const getTypesExpenses = async () => {

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'gastos-tipo/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                setTypeExpense(data)
            })
            .catch((error) => {
                console.log(error)
            })
    };

    return (
        <Fragment>
            <Card>
                <CardBody>
                    <div style={{ margin: 5 }}>
                        <div style={{ marginTop: 5, padding: '1em 1em 1em 1em' }} >
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div style={{marginRight: 'auto' }}>
                                    <h4><b>AGREGAR GASTO</b></h4>
                                </div>
                                <div>
                                    <Button
                                        color="primary"
                                        size='sm'
                                        onClick={() => {
                                            setOpenTypeExpensesForm(!openTypeExpensesForm);
                                        }}
                                    >
                                        {openTypeExpensesForm ? "Cerrar Formulario" : "Agregar Tipo de Gastos"}
                                    </Button>
                                </div>
                            </div>
                            <Row>
                                <Col md={openTypeExpensesForm == false ? 12 : 6} style={{ padding: '2em 2em' }}>
                                    <Row>
                                        <Col xs={12} md={6} >
                                            <TextField
                                                label="Nombre"
                                                value={nameExpense}
                                                onChange={(event) => {
                                                    setNameExpense(event.target.value)
                                                }}
                                                type="text"
                                                className="medical-material-form__field"
                                                error={errors.hasOwnProperty("nombre") ? errors.nombre !== "" : false}
                                                helperText={errors.nombre}
                                            />
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <TextField
                                                label="Nota"
                                                multiline
                                                value={noteExpense}
                                                onChange={(event) => {
                                                    setNoteExpense(event.target.value)
                                                }}
                                                type="text"
                                                className="medical-material-form__field"
                                                error={errors.hasOwnProperty("nota") ? errors.nota !== "" : false}
                                                helperText={errors.nota}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <TextField
                                                label="Tipo de Gasto"
                                                select
                                                value={typeExpenseSelected}
                                                onChange={(event) => {
                                                    setTypeExpenseSelected(event.target.value)
                                                }}
                                                className="medical-material-form__field"
                                                error={errors.hasOwnProperty("tipo_gasto") ? errors.tipo_gasto !== "" : false}
                                                helperText={errors.tipo_gasto}
                                            >
                                                {
                                                    typeExpense !== null && typeExpense !== undefined ?
                                                        typeExpense.map((typeExp) => {
                                                            return <MenuItem key={typeExp.id_tipo_gasto} value={typeExp.id_tipo_gasto}>{typeExp.nombre}</MenuItem>
                                                        })
                                                        : <MenuItem key={0} value={null}></MenuItem>
                                                }
                                            </TextField>
                                        </Col>

                                        <Col xs={12} md={6}>
                                            <MuiPickersUtilsProvider utils={MomentUtils} >
                                                <KeyboardDateTimePicker
                                                    required
                                                    value={dateExpense}
                                                    onChange={(date) => setDateExpense(date)}
                                                    label="Fecha del Gasto"
                                                    onError={console.log}
                                                    minDate={new Date("2020-01-01T00:00")}
                                                    format="yyyy/MM/DD"
                                                    //className={classes.date}
                                                    style={{ width: '100%' }}
                                                //disabled={this.props.dataPatient.dataPatient !== null}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={6}>
                                            <TextField
                                                label="Cliente"
                                                select
                                                value={thirdSelected}
                                                onChange={(event) => {
                                                    setThirdSelected(event.target.value)
                                                }}
                                                className="medical-material-form__field"
                                            /* error={errors.hasOwnProperty("tipo_gasto") ? errors.tipo_gasto !== "" : false}
                                            helperText={errors.tipo_gasto} */
                                            >
                                                {
                                                    thirds.map((third) => (
                                                        <MenuItem key={third.id_tercero} value={third.id_tercero}>{third.nombre}</MenuItem>
                                                    ))
                                                }
                                                <MenuItem key={0} value={null}></MenuItem>
                                            </TextField>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <TextField
                                                label="Importe"
                                                type='number'
                                                value={mount}
                                                onChange={(event) => {
                                                    setMount(event.target.value)
                                                }}
                                                className="medical-material-form__field"
                                                error={errors.hasOwnProperty("importe") ? errors.importe !== "" : false}
                                                helperText={errors.importe}
                                            />
                                        </Col>
                                        <Row>
                                            <Col xs={12} md={6}>
                                                <Row>
                                                    <Col>
                                                        <TextField
                                                            label="Impuesto"
                                                            type='text'
                                                            value={taxeName}
                                                            onChange={(event) => {
                                                                setTaxeName(event.target.value)
                                                            }}
                                                            className="medical-material-form__field"
                                                            error={errors.hasOwnProperty("impuestos") ? errors.impuestos !== "" : false}
                                                            helperText={errors.impuestos}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <TextField
                                                            label="Valor"
                                                            type='number'
                                                            value={taxeValue}
                                                            onChange={(event) => {
                                                                setTaxeValue(event.target.value)
                                                            }}
                                                            className="medical-material-form__field"
                                                            error={errors.hasOwnProperty("impuestos") ? errors.impuestos !== "" : false}
                                                            helperText={errors.impuestos}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <Tooltip title="Agregar Impuesto">
                                                            <IconButton aria-label="edit" onClick={() => {
                                                                if (taxeName !== '' && taxeValue !== 0) {
                                                                    includeTax(taxeName, taxeValue);
                                                                }
                                                            }}>
                                                                <AddCircleOutlineIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Col>
                                                </Row>

                                            </Col>
                                            <Col xs={12} md={6}>
                                                <TextField
                                                    label="Forma de Pago"
                                                    select
                                                    value={typeOfPayment}
                                                    onChange={(event) => {
                                                        setTypeOfPayment(event.target.value)
                                                    }}
                                                    className="medical-material-form__field"
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                    error={errors.hasOwnProperty("tipo_gasto") ? errors.tipo_gasto !== "" : false}
                                                    helperText={errors.tipo_gasto}
                                                >
                                                    <MenuItem key={1} value={'Efectivo'}>
                                                        Efectivo
                                                    </MenuItem>
                                                    <MenuItem key={2} value={'Tarjeta'}>
                                                        Tarjeta
                                                    </MenuItem>
                                                    <MenuItem key={3} value={'Cheque'}>
                                                        Cheque
                                                    </MenuItem>
                                                </TextField>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: 5 }}>
                                            <Col xs={12} md={6}>
                                                <TextField
                                                    label="Referencia"
                                                    type='number'
                                                    value={reference}
                                                    onChange={(event) => {
                                                        setReference(event.target.value)
                                                    }}
                                                    className="medical-material-form__field"
                                                    error={errors.hasOwnProperty("referencia") ? errors.referencia !== "" : false}
                                                    helperText={errors.referencia}
                                                />
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <FormGroup>
                                                    <Label for="exampleFile">Adjuntar Recibo de Pago</Label>
                                                    <Col>
                                                        <Input
                                                            type="file"
                                                            name="file"
                                                            id="exampleFile"
                                                            //value={fileSpeciality}
                                                            onChange={(e) => {
                                                                setFileExpense(e.target.files[0])
                                                                console.log(e.target.files[0])
                                                            }}
                                                            error={errors.hasOwnProperty("imagenRe") ? errors.imagenRe !== "" : false}
                                                            helperText={errors.imagenRe}
                                                        />
                                                        {/* <FormFeedback tooltip>
                                                            {
                                                                errors.hasOwnProperty("imagenRe") ? errors.imagenRe !== "" : false
                                                            }
                                                        </FormFeedback> */}
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {/* <Row>
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                <p>Drag 'n' drop some files here, or click to select files</p>
                                            </div>
                                            <div>{images}</div>
                                            <FormControl component={<renderDropZoneField input={files} onChange={files}/>} >
                                            </FormControl>
                                        </Row> */}
                                        <Row>

                                            <Col md={6}>
                                                {
                                                    taxes !== null && taxes.length > 0 ?
                                                        <Fragment>
                                                            <h5 style={{ marginTop: 20 }}>IMPUESTOS</h5>
                                                            {taxes.map((tax, index) => (
                                                                <div key={index}>
                                                                    <b>Nombre: {tax.impuesto} | Valor: {tax.valor}</b>
                                                                    <Tooltip title="Quitar Impuesto" style={{ padding: '5px 12px' }}>
                                                                        <IconButton aria-label="edit" onClick={() => {
                                                                            removeTax(tax.id);
                                                                        }}>
                                                                            <RemoveCircleOutlineIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                            ))}
                                                        </Fragment>
                                                        : null
                                                }
                                            </Col>
                                            <Col md={6}>
                                                {
                                                    mount !== 0 && mount !== '' ?
                                                        <h5 style={{ marginTop: 20 }}><b>IMPORTE: ${formatNumber(mount)}</b></h5>
                                                        : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Button
                                                    size="small"
                                                    style={{ marginTop: 10 }}
                                                    color="primary"
                                                    onClick={() => {
                                                        if (editExpense == true && idExpense !== '') {
                                                            updateExpense(idExpense);
                                                        } else {
                                                            saveExpense();
                                                        }
                                                    }}
                                                >
                                                    {editExpense ? "Editar" : "Guardar"}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Row>
                                </Col>
                                {openTypeExpensesForm ?
                                    <Col md={6}>
                                        <TypeExpensesForm setTypeExpense={setTypeExpense} />
                                    </Col>
                                    : null}
                            </Row>
                            <Row>
                                <Col>
                                    {
                                        loadTable ?
                                            <div className="text-center">
                                                <Spinner animation="border" style={{ color: '#4ce1b6' }} />
                                            </div>
                                            :
                                            <LoadInfo />
                                    }
                                </Col>
                            </Row>

                        </div>
                        {openAlert ?
                            <ModalUI
                                color={modalAlert.color}
                                title={modalAlert.title}
                                message={modalAlert.message}
                                modal={openAlert}
                                toggle={() => { setOpenAlert(!openAlert) }}
                                onOk={() => { setOpenAlert(!openAlert) }}
                            /> : null}
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    )
}

export default ExpensesSection